import { useDispatch } from 'react-redux';

import { MIXPANEL_EVENTS } from 'constants/constants';
import { resetAnalytics, unregisterSuperProperty } from 'utils/analytics';
// import useSession from 'hooks/useSession';
import { logout } from 'state/actions/userActions';

export default () => {
  const dispatch = useDispatch();
  // const { token } = useSession();

  const logoutRequest = async () => {
    // await dispatch(unregisterDevice(token));
    dispatch(logout());
    resetAnalytics();
    unregisterSuperProperty(MIXPANEL_EVENTS.loggedIn);
    localStorage.clear();
  };

  return {
    logout: logoutRequest
  };
};
